module.exports = __webpack_public_path__ + "img/pl.57208dbc.svg";